import {ParameterBase} from '~/app/core/reports/models/ParameterBase';

export class DateRangeField extends ParameterBase<any> {
  controlType = 'daterangefield';
  format = 'yyyy/MM/dd';
  showMasterLabel =  false;
}
